import { createDataTool } from "./data-tool-app.js";
import { formatYaml } from "./yaml-formatter-core.js";
import "./data-tool.css";

createDataTool({
  inputLabel: "YAML",
  outputLabel: "YAML",
  extensions: ["yaml", "yml"],
  defaultFileName: "document.yaml",
  exampleFileName: "config.yaml",
  example: "# Project configuration\nproject: smallpdf.app\ntools: [format, compare]\nactive: true",
  outputExtension: "yaml",
  mimeType: "application/yaml",
  suffix: "formatted",
  transform(source) {
    return formatYaml(source, {
      indentation: document.getElementById("dataToolIndentation")?.value || 2
    });
  },
  successMessage: result => `Valid YAML formatted across ${result.lines.toLocaleString("en-US")} lines.`
});
